import { Button, Carousel, Col, Dropdown, Row } from 'react-bootstrap';
import React, { SetStateAction, useEffect, useState } from 'react';
import { FaEllipsisV, FaMoneyBillWave } from 'react-icons/fa';
import { Checkbox } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { IOffer } from '../../../../../model/offer/IOffer';
import { IParams } from '../../../../../model/shared/IParams';
import { RatingStar } from '../../../../../shared/components/RatingStar';
import { useSearchQuery } from '../../../../../shared/hooks/useSearchQuery';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';
import { useTranslation } from 'react-i18next';
import { ErrorToast } from '../../../../../utils/toasters';
import { BookingService } from '../service';
import BookingOfferModal from './modal';
import { CustomImageHandler } from '../../../../../shared/components/CustomImageHandler';
import {
    checkOfferType,
    clearHtmlFromString,
    formatDate,
    getNumberPosts,
    getSocialIcons,
    truncateString,
} from '../../../../../shared/functions/Functions';
import { priceSplitter } from '../../../../../utils/helpers/priceSplitter';
import { BookingAcceptOfferModal } from './BookingAcceptOfferModal';
import { IDeclineOffer } from '../../../../influencer/offer/dto/IDeclineOffer';
import { DeclineOfferModal } from '../../../../influencer/offer/modal/offer-modal/components/DeclineOfferModal';
import { ConfirmSendingOfferModal } from '../../../../influencer/offer/modal/offer-modal/components/ConfirmSendingOfferModal';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import ChildOfferModal from '../child-offer/modal';
import { setSelectedUser } from '../../../../../store/brand/childOfferBrandSlice';
import { User } from '../../../../../model/user/User';
import TooltipOverlay from '../../../../../shared/components/tooltip/Tooltip';
import { ConfirmationModal } from '../../../../../shared/components/modal/ConfirmationModal';
import { CheckModalIcon, CrossModalIcon, DeleteIcon, EditIcon } from '../../../../../shared/Icons';

export interface IBookCardProps {
    offers: IOffer[];
    setOffers: React.Dispatch<React.SetStateAction<IOffer[]>>;
    acceptOffer: (offerId: number) => void;
    declineOffer: (offerId: number) => void;
    approveProposal?: (offerId: number) => void;
    declineProposal?: (offerId: number) => void;
    deleteProposal?: (offerId: number) => void;
    selectOffer: (offerId: number, isSelected: boolean) => void;
    setBestPickAction: (offerId: number) => void;
    setUpdateOffers: React.Dispatch<React.SetStateAction<boolean>>;
    setDeclineReason: React.Dispatch<SetStateAction<IDeclineOffer>>;
}

export function BookingCardItem({
    offers,
    acceptOffer,
    declineOffer,
    approveProposal,
    declineProposal,
    deleteProposal,
    selectOffer,
    setUpdateOffers,
    setBestPickAction,
    setDeclineReason,
}: IBookCardProps) {
    const { t } = useTranslation();
    const { id: campaignId } = useParams<keyof IParams>();
    const navigate = useNavigate();
    const whoImpersonate = localStorage.getItem('whoImpersonate');
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [showChildBookingModal, setShowChildBookingModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showDeclineModal, setShowDeclineModal] = useState(false);
    const [showDeleteProposalModal, setShowDeleteProposalModal] = useState(false);
    const [isProposalDecline, setIsProposalDecline] = useState(false);
    const [offerId, setOfferId] = useState(0);
    const [offerData, setOfferData] = useState<IOffer>();
    const [approveTarget, setApproveTarget] = useState<IOffer>();
    const [userId, setUserId] = useState(0);
    const [offerModalStatus, setOfferModalStatus] = useState('');
    const {
        user: { isSupervisor, isClient },
    } = useSelector((state: IAllStates) => state.auth);
    const { isChildCampaign } = useSelector((state: IAllStates) => state.selectedCampaign);
    const pendingAndNegotiateStatus = ['pending', 'negotiate'];
    const queryUserId = useSearchQuery('userId');
    const queryOfferId = useSearchQuery('offerId');
    const dispatch = useDispatch();

    const canSelectBestPick = (offerStatus: string) => {
        if ((whoImpersonate || isSupervisor) && pendingAndNegotiateStatus.includes(offerStatus)) {
            return true;
        }
        return false;
    };
    const openOfferModal = (id: number, user: number, negotiateStatus = false) => {
        setOfferId(id);
        setUserId(user);
        setShowBookingModal(true);
        if (negotiateStatus) {
            setOfferModalStatus('negotiate');
        }
    };
    const openChildOfferModal = (user: User) => {
        setUserId(userId);
        setShowChildBookingModal(true);
        dispatch(setSelectedUser(user));
    };

    const openModalAction = (isLongTerm: boolean, user: User, offerId?: number, negotiateStatus = false) => {
        isLongTerm ? openChildOfferModal(user) : openOfferModal(offerId ?? 0, user.id, negotiateStatus);
    };

    const closeModal = () => {
        setShowBookingModal(false);
        setOfferModalStatus('');
    };
    const closeConfirmModal = () => {
        setShowConfirmModal(false);
    };

    const openConfirmModal = (id: number, offer: IOffer) => {
        setShowConfirmModal(true);
        setOfferId(id);
        setOfferData(offer);
    };
    const opeDeclineModal = (id: number, offer: IOffer) => {
        setShowDeclineModal(true);
        setIsProposalDecline(false);
        setOfferId(id);
        setOfferData(offer);
    };

    const opeProposalDeclineModal = (id: number, offer: IOffer) => {
        setShowDeclineModal(true);
        setIsProposalDecline(true);
        setOfferId(id);
        setOfferData(offer);
    };

    const declineOfferAction = () => {
        if (isProposalDecline) {
            if (declineProposal) {
                declineProposal(offerId ?? 0);
            }
        } else if (declineOffer) {
            declineOffer(offerId ?? 0);
        }
        setShowDeclineModal(false);
    };

    const approveProposalAction = (id: number) => {
        if (approveProposal) {
            approveProposal(id);
        }
    };

    const openDeleteProposalModal = (id: number) => {
        setShowDeleteProposalModal(true);
        setOfferId(id);
    };

    const deleteProposalAction = () => {
        if (deleteProposal) {
            deleteProposal(offerId ?? 0);
        }
    };

    const acceptOfferConfirmModal = () => {
        acceptOffer(offerId);
    };

    const openOfferOnNotificationClick = (notificationOfferId: number, notificationUserId: number) => {
        BookingService.getOffer(notificationUserId, Number(campaignId))
            .then(response => {
                const selectedOffer = response?.offers?.[0];
                if (selectedOffer?.isExpired) {
                    setOfferModalStatus('negotiate');
                }
                openOfferModal(notificationOfferId, notificationUserId, false);
            })
            .catch(err => ErrorToast(err));
    };

    useEffect(() => {
        if (queryUserId && queryOfferId && campaignId) {
            openOfferOnNotificationClick(Number(queryOfferId), Number(queryUserId));
            navigate(`/brand/campaign/book/${campaignId}`);
        }
    }, [queryUserId, queryOfferId, campaignId]);

    return (
        <>
            <BookingOfferModal
                show={showBookingModal}
                closeModal={closeModal}
                offerId={offerId}
                modalStatus={offerModalStatus}
                userId={userId}
                acceptOffer={acceptOffer}
                declineOffer={declineOffer}
                approveProposal={approveProposal}
                declineProposal={declineProposal}
                deleteProposal={deleteProposal}
                selectOffer={selectOffer}
                setUpdateList={setUpdateOffers}
                setDeclineReason={setDeclineReason}
            />
            <ChildOfferModal
                closeModal={() => setShowChildBookingModal(false)}
                show={showChildBookingModal}
                setUpdateList={setUpdateOffers}
            />
            <BookingAcceptOfferModal
                action={acceptOfferConfirmModal}
                show={showConfirmModal}
                closeModal={closeConfirmModal}
                user={offerData?.user}
                grandTotal={priceSplitter(offerData?.price)}
                nbPosts={getNumberPosts(offerData?.totalPlatforms)}
            />
            <DeclineOfferModal
                date={formatDate(offerData?.createdAt ?? '')}
                declineOffer={declineOfferAction}
                show={showDeclineModal}
                closeModal={() => setShowDeclineModal(false)}
                setDeclineReason={setDeclineReason}
            />
            <ConfirmSendingOfferModal
                action={() => approveProposalAction(approveTarget?.id ?? 0)}
                grandTotal={priceSplitter(approveTarget?.price)}
                show={!!approveTarget}
                disableButton={false}
                closeModal={() => setApproveTarget(undefined)}
                nbPosts={getNumberPosts(approveTarget?.totalPlatforms)}
                user={approveTarget?.user}
                isProposalApproval={true}
            />
            <ConfirmationModal
                show={showDeleteProposalModal}
                closeModal={() => setShowDeleteProposalModal(false)}
                action={deleteProposalAction}
                title={t('brand.campaign.book.offer.delete_proposal')}
                description={t('brand.campaign.book.offer.delete_proposal_confirm')}
            />

            {offers?.map(offer => {
                const offerUserName =
                    offer?.user?.displayName === null
                        ? offer?.user.firstName + ' ' + offer.user.lastName
                        : offer?.user?.displayName;
                const truncatedOfferUserName = truncateString(offerUserName, 20);
                const isOfferUserNameTruncated = offerUserName.length > 20;
                const proposalStatusClass = offer?.isApproved
                    ? 'proposal-approved'
                    : offer?.isDeclined
                    ? 'proposal-declined'
                    : 'primary';
                const proposalStatusText = offer?.isApproved
                    ? t('brand.campaign.book.offer.approved')
                    : offer?.isDeclined
                    ? t('brand.campaign.book.offer.declined')
                    : t('general.campaign_status.proposed');

                return (
                    <Col key={`${offer?.id}-card-item`} lg={6} className="mb-4">
                        <Row
                            className={`booking-card border-${offer.status} ${
                                offer?.isProposed ? 'border-proposed' : ''
                            } m-0 position-relative overflow-hidden`}
                        >
                            {offer?.user?.agencyCompany?.id && (
                                <Col md={5} className="offer-by-agency-wrapper">
                                    <div className="offer-by-agency-badge mb-3 mb-md-0">
                                        <img src="/icons/building-icon.svg" alt="Building icon" />
                                        <span className="pl-1">
                                            {t('general.offerByAgency')}
                                            <br />
                                            <span className="text-primary">
                                                {offer?.user?.agencyCompany?.displayName ?? ''}
                                            </span>
                                        </span>
                                    </div>
                                </Col>
                            )}
                            <Col
                                md={5}
                                onClick={() =>
                                    openModalAction(
                                        offer?.isLongTerm,
                                        offer.user,
                                        offer?.id,
                                        offer.buttonType === 'Resume'
                                    )
                                }
                                className="p-0 cursor-pointer overflow-hidden position-relative"
                            >
                                {(offer?.isLongTerm || offer?.isAddonsOnly || offer?.isOnTop) && (
                                    <div className="diagonal-text-bottom-left">
                                        <span>
                                            {t(
                                                `brand.campaign.briefing.overview_card.${checkOfferType(
                                                    offer?.isLongTerm,
                                                    offer?.isOnTop,
                                                    offer?.isAddonsOnly,
                                                    true
                                                )}`
                                            )}
                                        </span>
                                    </div>
                                )}
                                <Carousel
                                    controls={false}
                                    indicators={false}
                                    id="booking-carousel"
                                    className="dashboard-slider"
                                >
                                    {offer?.user?.feedItems.length > 0 ? (
                                        offer?.user?.feedItems?.map(
                                            item =>
                                                item.postImages.length > 0 && (
                                                    <Carousel.Item key={item.id}>
                                                        <CustomImageHandler
                                                            altTag={item.postImages[0]?.name ?? ''}
                                                            classes="booking-card-image"
                                                            thumbnailPath={item.postImages[0]?.thumbnail ?? ''}
                                                            photoPath={item.postImages[0]?.path ?? ''}
                                                        />
                                                    </Carousel.Item>
                                                )
                                        )
                                    ) : (
                                        <Carousel.Item>
                                            <CustomImageHandler
                                                altTag={offer?.user?.profilePhoto?.name ?? ''}
                                                classes="booking-card-image"
                                                photoPath={offer?.user?.profilePhoto?.thumbnail ?? ''}
                                                thumbnailPath={offer?.user?.profilePhoto?.thumbnail ?? ''}
                                            />
                                        </Carousel.Item>
                                    )}
                                </Carousel>
                                <div className="booking-card-info ">
                                    <div className="position-relative">
                                        <CustomImageHandler
                                            altTag={offer?.user?.profilePhoto?.name ?? ''}
                                            classes={`user-img-rounded cursor-pointer  ${
                                                offer?.isBestPick && 'best-pick-border'
                                            }`}
                                            thumbnailPath={offer?.user?.profilePhoto?.thumbnail}
                                            photoPath={offer?.user?.profilePhoto?.path ?? null}
                                            name={
                                                offer?.user?.displayName === null
                                                    ? offer?.user.firstName + ' ' + offer.user.lastName
                                                    : offer?.user?.displayName
                                            }
                                        />
                                    </div>
                                    <div className="ml-2">
                                        <TooltipOverlay content={isOfferUserNameTruncated ? offerUserName : ''}>
                                            <p className="text-shadow cursor-pointer pl-0">{truncatedOfferUserName}</p>
                                        </TooltipOverlay>
                                        {offer?.user?.totalRating ? (
                                            <RatingStar rating={offer?.user?.totalRating} />
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </Col>
                            <Col md={7} className="d-flex flex-column justify-content-between py-3">
                                <div className="d-flex flex-column justify-content-between">
                                    <div className="d-flex justify-content-between">
                                        {offer.isAddonsOnly ? (
                                            <h6>{t(`brand.campaign.briefing.overview_card.addons_only`)}</h6>
                                        ) : (
                                            <div className="d-flex flex-wrap">
                                                {offer?.totalPlatforms?.map((platform, i) => (
                                                    <React.Fragment key={platform?.id + `index: ${i}`}>
                                                        {getSocialIcons({
                                                            iconPath: platform.path,
                                                            dataTop: `x${platform.nbPostsTotal}`,
                                                            dataDown: numberFormatter(platform.followers),
                                                            colorText: 'primary',
                                                            parentClasses: 'mr-2',
                                                        })}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        )}
                                        {/*<div>*/}
                                        {/*    <img*/}
                                        {/*        onClick={*/}
                                        {/*            canSelectBestPick(offer?.status ?? '')*/}
                                        {/*                ? () => setBestPickAction(offer?.id)*/}
                                        {/*                : undefined*/}
                                        {/*        }*/}
                                        {/*        height="25"*/}
                                        {/*        width="25"*/}
                                        {/*        className={`${canSelectBestPick(offer?.status) && 'cursor-pointer'} ${*/}
                                        {/*            !canSelectBestPick(offer?.status) && !offer.isBestPick && 'd-none'*/}
                                        {/*        } mr-2 img-cover`}*/}
                                        {/*        src={*/}
                                        {/*            offer.isBestPick*/}
                                        {/*                ? '/icons/img_best_pick_diamond.png'*/}
                                        {/*                : '/icons/img_best_pick_diamond_grey.png'*/}
                                        {/*        }*/}
                                        {/*        alt="best-pick"*/}
                                        {/*    />*/}
                                        {/*    <Checkbox*/}
                                        {/*        checked={offer?.isSelected}*/}
                                        {/*        onClick={() => selectOffer(offer?.id, !offer.isSelected)}*/}
                                        {/*        className={`${*/}
                                        {/*            (offer?.buttonType === 'Open' ||*/}
                                        {/*                offer.buttonType === 'Resume' ||*/}
                                        {/*                isChildCampaign) &&*/}
                                        {/*            'd-none'*/}
                                        {/*        } p-0`}*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        <div>
                                            <TooltipOverlay content={t('brand.campaign.book.offer.offer_sent_tooltip')}>
                                                <img
                                                    height="40"
                                                    width="40"
                                                    className={`${
                                                        !offer?.isConvertedToOffer && 'd-none'
                                                    } cursor-pointer`}
                                                    src="/icons/approved-icon.svg"
                                                    alt="Offer sent"
                                                />
                                            </TooltipOverlay>
                                        </div>
                                    </div>
                                    <p
                                        onClick={() =>
                                            openModalAction(
                                                offer?.isLongTerm,
                                                offer.user,
                                                offer?.id,
                                                offer.buttonType === 'Resume'
                                            )
                                        }
                                        className="intro  cursor-pointer"
                                    >
                                        {clearHtmlFromString(
                                            !!offer?.description ? offer?.description : offer?.user?.about ?? ''
                                        )}
                                    </p>
                                </div>

                                <div>
                                    {!offer?.description && !offer?.user?.about && (
                                        <div className="d-flex mb-2 align-items-center">
                                            <img src="/icons/poll-h.svg" alt="description" />
                                            <div className="ml-2 text-muted">{t('general.no_description')}</div>
                                        </div>
                                    )}
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div>
                                            <div className="d-flex align-items-center">
                                                {offer?.isLongTerm ? (
                                                    <p className="text-primary mb-0">
                                                        {t('brand.campaign.book.offer.part_long_term')}
                                                    </p>
                                                ) : (
                                                    <h4 className="mb-0 euro-symbol euro-symbol text-nowrap">
                                                        {priceSplitter(Math.round(offer?.price))}
                                                    </h4>
                                                )}
                                                {(offer?.isRequested || offer?.isProposed) && (
                                                    <p
                                                        className={`mx-2 status ${
                                                            offer?.isProposed ? proposalStatusClass : 'invite'
                                                        } text-dark`}
                                                    >
                                                        {offer?.isProposed
                                                            ? proposalStatusText
                                                            : t('general.campaign_status.invite')}
                                                    </p>
                                                )}
                                            </div>
                                            <div className="d-flex align-items-start flex-column">
                                                {!!offer?.additionalPrice && (
                                                    <span className="text-muted d-flex align-items-center mt-1">
                                                        <FaMoneyBillWave className="text-primary mr-1 font-16" />
                                                        <p className="font-9 ">
                                                            {t('brand.campaign.book.offer.additional_costs_included')}
                                                        </p>
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div className="d-flex flex-wrap justify-content-end">
                                            {!isClient && offer?.canCounter && (
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        className="mr-2"
                                                        variant="light"
                                                        id="dropdown-basic"
                                                    >
                                                        <FaEllipsisV className="text-secondary" />
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item
                                                            onClick={() =>
                                                                openModalAction(
                                                                    offer?.isLongTerm,
                                                                    offer.user,
                                                                    offer?.id,
                                                                    true
                                                                )
                                                            }
                                                            className="d-flex align-items-center"
                                                        >
                                                            <i className="fi fi-rr-messages-question icon-fixed me-2"></i>
                                                            {t('general.button.negotiate')}
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => opeDeclineModal(offer?.id, offer)}
                                                            className="d-flex align-items-center danger-hover"
                                                        >
                                                            <CrossModalIcon width={16} height={16} className="me-2" />
                                                            {t('brand.campaign.book.offer.deny_offer')}
                                                        </Dropdown.Item>
                                                        {/* {canSelectBestPick(offer?.status ?? '') && (
                                                            <Dropdown.Item onClick={() => setBestPickAction(offer?.id)}>
                                                                {offer?.isBestPick
                                                                    ? t(
                                                                          'brand.campaign.book.offer.filters.remove_best_pick'
                                                                      )
                                                                    : t(
                                                                          'brand.campaign.book.offer.filters.set_best_pick'
                                                                      )}
                                                            </Dropdown.Item>
                                                        )} */}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}
                                            {isClient &&
                                                offer?.isProposed &&
                                                !offer?.isApproved &&
                                                !offer?.isDeclined && (
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            className="mr-2"
                                                            variant="light"
                                                            id="dropdown-basic"
                                                        >
                                                            <FaEllipsisV className="text-secondary" />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item onClick={() => setApproveTarget(offer)}>
                                                                <div className="d-flex align-items-center">
                                                                    <CheckModalIcon
                                                                        width={14}
                                                                        height={14}
                                                                        className="me-2"
                                                                    />
                                                                    {t('brand.campaign.book.offer.approve_proposal')}
                                                                </div>
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                                onClick={() =>
                                                                    opeProposalDeclineModal(offer?.id, offer)
                                                                }
                                                            >
                                                                <div className="d-flex align-items-center">
                                                                    <CrossModalIcon
                                                                        width={14}
                                                                        height={14}
                                                                        className="me-2"
                                                                    />
                                                                    {t('brand.campaign.book.offer.decline_proposal')}
                                                                </div>
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                )}
                                            {!isClient && offer?.isProposed && !offer?.isApproved && (
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                        className="mr-2"
                                                        variant="light"
                                                        id="dropdown-basic"
                                                    >
                                                        <FaEllipsisV className="text-secondary" />
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item
                                                            onClick={() =>
                                                                openModalAction(
                                                                    offer?.isLongTerm,
                                                                    offer.user,
                                                                    offer?.id,
                                                                    true
                                                                )
                                                            }
                                                        >
                                                            <EditIcon
                                                                width={20}
                                                                height={20}
                                                                className="dropdown-menu-icon"
                                                            />
                                                            {t('brand.campaign.book.offer.edit_proposal')}
                                                        </Dropdown.Item>
                                                        {!offer?.isDeclined && (
                                                            <Dropdown.Item
                                                                className="text-danger"
                                                                onClick={() => openDeleteProposalModal(offer?.id)}
                                                            >
                                                                <DeleteIcon
                                                                    width={20}
                                                                    height={20}
                                                                    className="dropdown-menu-icon"
                                                                />
                                                                {t('brand.campaign.book.offer.delete_proposal')}
                                                            </Dropdown.Item>
                                                        )}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            )}
                                            <Button
                                                variant="outline-primary"
                                                size="sm"
                                                onClick={
                                                    isClient ||
                                                    offer?.buttonType === 'Open' ||
                                                    offer.buttonType === 'Resume'
                                                        ? () =>
                                                              openModalAction(
                                                                  offer?.isLongTerm,
                                                                  offer.user,
                                                                  offer?.id,
                                                                  offer.buttonType === 'Resume'
                                                              )
                                                        : () => openConfirmModal(offer?.id, offer)
                                                }
                                            >
                                                {t(`general.button.${isClient ? 'Open' : offer?.buttonType}`)}
                                            </Button>
                                            {offer?.hasUnreadComments && (
                                                <div
                                                    id="bullet"
                                                    className="red-dot position-relative"
                                                    style={{ top: '-4px', right: '10px' }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                );
            })}
        </>
    );
}
